import { Alert, AlertDescription, AlertTitle } from "@chakra-ui/react";
import { AlertIcon } from "view-layer/components/common/icons/AlertIcon";

export const CardPaymentSuccess = () => (
  <Alert status="success" variant="success" data-testid="payment-success-message">
    <AlertIcon status="success" />
    <AlertTitle>Payment successful</AlertTitle>
    <AlertDescription>Thank you for your payment! You will receive a confirmation email shortly.</AlertDescription>
  </Alert>
);